<zelis-card
  class="ancillary-networks"
  [ngClass]="classes"
  [elevated]="true"
  [disableHover]="true"
>
  <mat-card-content class="flex flex-col md:flex-row md:items-center gap-4">
    <div class="flex flex-col md:w-1/3">
      <h4 class="mb-2 text-lg">
        {{ 'ancillary_networks_title' | translate }}
      </h4>
      <div>{{ 'ancillary_networks_description' | translate }}</div>
    </div>
    <div
      class="ancillary-network-links flex flex-col md:flex-row md:w-2/3 gap-2"
    >
      <zelis-button
        *ngFor="let network of ancillaryNetworks; trackBy: trackByNetworkLabel"
        appGtm
        [gtmOnClick]="true"
        [gtmData]="{
          event: 'ancillary-care',
          action: network.label | translate,
          label: network.link | translate
        }"
        (click)="openNetworkLink(network.link)"
        variant="stroked"
        color="accent"
        size="large"
        class="no-external-link-indicator"
        [nowrap]="false"
        [fullWidth]="ancillaryNetworks?.length > 1"
      >
        <span>{{ network.label | translate }}</span>
        <mat-icon
          aria-hidden="false"
          [attr.aria-label]="'app_global_opens_in_new_tab' | translate"
          [inline]="true"
          class="w-6"
          zelisButtonIcon
        >
          open_in_new
        </mat-icon>
      </zelis-button>
    </div>
  </mat-card-content>
</zelis-card>
